import { render, staticRenderFns } from "./videoBlock.vue?vue&type=template&id=05fe3b7a"
import script from "./videoBlock.vue?vue&type=script&lang=js"
export * from "./videoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/vercel/path0/components/ui/img.vue').default})
